<template>
  <div>
    <div class="title-bar title-h3">
      이벤트/알람 정책
    </div>
    <el-row>
      <el-tree class="tree-editor" ref="eventAlarmRuleTree" :data="eventAlarmRuleTreeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false"
        :render-content="renderContent" highlight-current @node-click="clickNode"></el-tree>
    </el-row>
    <w-add-rule-popup ref="addRulePopup" :rule-type="ruleType" :managetype-id="managetypeId" @close="loadData"/>
    <w-modify-rule-popup ref="modifyRulePopup" :rule-type="ruleType" @close="loadData"/>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import EventAlarmRuleSettingsAPI from '@/api/settings/common/event-alarm-rule-settings';
import { defaultProps } from '@/constants/tree';
import { ruleType } from '@/constants/rule';
import { isTrue } from '@/utils/boolean';
import msgUtil from '@/utils/message';
import WAddRulePopup from '../../popup/AddRulePopup';
import WModifyRulePopup from '../../popup/ModifyRulePopup';

export default {
  name: 'WRscTree',
  components: {
    WAddRulePopup,
    WModifyRulePopup,
  },
  data() {
    return {
      managetypeId: null,
      ruleType: ruleType.EVENT,
      defaultProps,
      selectedNode: null,
      eventAlarmRuleTreeData: [],
      modifiedRule: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      EventAlarmRuleSettingsAPI.getEventAlarmRuleTree().then((response) => {
        const result = response.data.data;
        if (!isNil(result)) {
          this.eventAlarmRuleTreeData = cloneDeep(response.data.data);
          this.$nextTick(() => {
            const eventAlarmRuleTree = this.$refs.eventAlarmRuleTree;
            const firstGroup = this.eventAlarmRuleTreeData[0];
            if (!isNil(firstGroup.children)) {
              const firstNode = firstGroup.children[0];
              eventAlarmRuleTree.getNode(firstGroup.treeKey).expanded = true;
              eventAlarmRuleTree.setCurrentKey(firstNode.treeKey);
              this.clickNode(firstNode);
            }
          });
        }
      });
    },
    renderContent(h, { data }) {
      if (!data.leaf) {
        return (
          <span class="el-tree-node__label" >
            <span>
              <span class="tree-node-edit-icon content-margin-r" on-click={() => this.addRule(data)}>
                <i class="fas fa-plus-circle"></i>
              </span>
              <span>{data.label}</span>
            </span>
          </span>
        );
      } else if (!isTrue(data.defaultFlag)) {
        return (
          <span class="el-tree-node__label" >
            <span>
              <span class="tree-node-edit-icon mini content-margin-r">
                <span class="icon-margin-r" on-click={() => this.modifyRule(data)}><i class="far fa-pen"></i></span>
                <span on-click={() => this.deleteRule(data)}><i class="far fa-minus-circle"></i></span>
              </span>
              <span>{data.label}</span>
            </span>
          </span>
        );
      }
      return (
        <span class="el-tree-node__label" >
          <span>
            <span class="tree-node-edit-icon mini content-margin-r">
              <span class="icon-margin-r" on-click={() => this.modifyRule(data)}><i class="far fa-pen"></i></span>
            </span>
            <span>{data.label}</span>
          </span>
        </span>
      );
    },
    addRule(data) {
      this.managetypeId = data.managetypeId;
      this.$nextTick(() => {
        this.$refs.addRulePopup.open();
      });
    },
    modifyRule(data) {
      this.$refs.modifyRulePopup.open(cloneDeep(data));
    },
    /**
     * 이벤트/알람 정책을 삭제한다.
     * @return {[type]} [description]
     * @author jda
     */
    deleteRule(rule) {
      const h = this.$createElement; // 개행처리 위해 사용 - 템플릿 리터럴 적용 불가
      const desc = '해당 정책 장비의 이벤트/알람 정책은 OS에 따라 재설정됩니다.'; // 도움말 추가
      const message = h('div', { ref: 'myRef' }, [
        h('div', null, ...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)),
        h('div', null, desc),
      ]);
      this.$confirm(...msgUtil.getCustomConfirmData(message)).then(() => {
        EventAlarmRuleSettingsAPI.deleteEventAlarmRule(rule)
          .then((response) => {
            if (response.data.success) {
              this.loadData();
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '정책', true));
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '정책', false));
            }
          });
      }).catch(() => {});
    },
    clickNode(nodeData) {
      if (nodeData.leaf) {
        this.selectedNode = nodeData;
        this.$emit('select-rule', this.selectedNode);
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventAlarmRuleSettings/components/EventAlarmRuleTree.vue